import { useEffect, useState } from "react";
import Modal from "react-modal";
import { AGButton, CloseIcon } from "./style";

export interface DeleteSuccessModalProps {
	visible: boolean;
	toggleModal: () => void;
	offeringType: string;
}
const DeleteSuccessModal = ({
	visible,
	toggleModal,
	offeringType
}: DeleteSuccessModalProps) => {
	const handleClose = () => {
		toggleModal();
	};
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setScreenWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	const customStyles = {
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			borderRadius: 10,
			padding: "20px 20px 0px ",
			width: screenWidth < 540 ? "90%" : 500,
			fontFamily:
				"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
		},
		overlay: {
			zIndex: 99999999999,
		},
	};
	return (
		<Modal
			isOpen={visible}
			style={customStyles}
			contentLabel="Example Modal">
			<CloseIcon onClick={handleClose}>✖</CloseIcon>

			<div
				style={{
					fontSize: 16,
					fontWeight: 600,
					fontFamily:
						"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
					paddingRight: 20,
				}}>
				{`${offeringType.charAt(0).toUpperCase()}${offeringType.slice(1)} deleted`}
			</div>
			<div style={{ marginTop: 16, fontSize: 14 }}>
				{`The ${offeringType} is deleted successfully!`}
			</div>
			<div
				style={{
					margin: "20px 0 10px auto",
					width: "100%",
					textAlign: "right",
				}}>
				<AGButton
					onClick={handleClose}
					style={{ background: "#D9D9D9 " }}>
					OK
				</AGButton>
			</div>
		</Modal>
	);
};

export default DeleteSuccessModal;
